export enum PosthogEvent {
   // CLICK
   NxtPlanClickFAQ = 'NxtPlanClickFAQ',
   NxtPlanClickSelectSlotPerDay = 'NxtPlanClickSelectSlotPerDay',

   // CLICK PLAN
   NxtPlanClickPlanMagicWand = 'NxtPlanClickPlanMagicWand',
   NxtPlanSubmitPlanMagicWand = 'NxtPlanSubmitPlanMagicWand',
   NxtPlanClickPlanPlus = 'NxtPlanClickPlanPlus',
   NxtPlanClickCpsInSidePanel = 'NxtPlanClickCpsInSidePanel',
   NxtPlanClickHideTeamsWithoutRequests = 'NxtPlanClickHideTeamsWithoutRequests',

   NxtPlanClickOpenInMatchViaSidePanel = 'NxtPlanClickOpenInMatchViaSidePanel',
   NxtPlanClickOpenInExternalViaSidePanel = 'NxtPlanClickOpenInExternalViaSidePanel',

   // TRACK
   NxtPlanTrackSearchInPlanning = 'NxtPlanTrackSearchInPlanning',
   NxtPlanTrackSearchInSidePanel = 'NxtPlanTrackSearchInSidePanel',
   NxtPlanTrackAppMount = 'NxtPlanTrackAppMount',

   NxtPlanTrackOverviewHover = 'NxtPlanTrackOverviewHover',

   // SAVE
   NxtPlanSaveMove = 'NxtPlanSaveMove',
   NxtPlanSaveCopy = 'NxtPlanSaveCopy',

   // CUSTOMER
   NxtPlanCustomerPagination = 'NxtPlanCustomerPagination',
   NxtPlanClickCustomerItem = 'NxtPlanClickCustomerItem',
   NxtPlanCustomerSearch = 'NxtPlanCustomerSearch',
   NxtPlanChangeCustomerName = 'NxtPlanChangeCustomerName',
   NxtPlanChangeCustomerExternalRef = 'NxtPlanChangeCustomerExternalRef',
   NxtPlanChangeCustomerAddress = 'NxtPlanChangeCustomerAddress',
   NxtPlanClickCustomerCompanyNumber = 'NxtPlanClickCustomerCompanyNumber',
   NxtPlanCustomerUpdate = 'NxtPlanCustomerUpdate',
   NxtPlanCustomerCancel = 'NxtPlanCustomerCancel',
}
